import React from 'react';
import { LocaleIcon, UserIcon } from '../';
import { getCurrentLocale } from '../../utils/localeUtils';
import './iconbar.sass';

const MobileMenuButtons = (props, context) => {
    const { currentLocale } = getCurrentLocale(props.localeOptions, props.locale, context.messages.locale);

    return (
        <div className="mobile-buttons">
            {!props.hideLocale ?
                <LocaleIcon
                    currentLocale={currentLocale}
                    isActive={props.isLocaleActive}/> : <span/>}
            {!props.hideSignIn ?
                <UserIcon
                    isLoggedIn={props.isLoggedIn}
                    mobileUserActive={props.mobileUserActive}
                    signInLinks={props.signInLinks}/>
            : <span/>}
        </div>
    );
};

MobileMenuButtons.contextTypes = {
    messages: React.PropTypes.object
};

MobileMenuButtons.propTypes = {
    isLocaleActive: React.PropTypes.bool,
    locale: React.PropTypes.string,
    localeOptions: React.PropTypes.array,
    isLoggedIn: React.PropTypes.bool,
    hideLocale: React.PropTypes.bool,
    hideSignIn: React.PropTypes.bool,
    mobileUserActive: React.PropTypes.bool,
    signInLinks: React.PropTypes.array
};

export default MobileMenuButtons;



/** WEBPACK FOOTER **
 ** ./app/scripts/components/rightNav/MobileMenuButtons.js
 **/